import { render, staticRenderFns } from "./videoEmbed.vue?vue&type=template&id=2aac5467"
import script from "./videoEmbed.vue?vue&type=script&lang=js"
export * from "./videoEmbed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Img: require('/vercel/path0/components/ui/img.vue').default})
